/**
 * @generated SignedSource<<4c911c94a4bf95fe37f378ad78cf5a46>>
 * @relayHash aa2c7b7b5fafc0561e2dd07ff22e395e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa2c7b7b5fafc0561e2dd07ff22e395e

import type { ConcreteRequest } from 'relay-runtime';
export type ItemPickerLabelPermissionQuery$variables = {
  owner: string;
  repo: string;
};
export type ItemPickerLabelPermissionQuery$data = {
  readonly repository: {
    readonly viewerIssueCreationPermissions: {
      readonly labelable: boolean;
    };
  } | null | undefined;
};
export type ItemPickerLabelPermissionQuery = {
  response: ItemPickerLabelPermissionQuery$data;
  variables: ItemPickerLabelPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "repo"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "repo"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueCreationPermissions",
  "kind": "LinkedField",
  "name": "viewerIssueCreationPermissions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "labelable",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemPickerLabelPermissionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ItemPickerLabelPermissionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "aa2c7b7b5fafc0561e2dd07ff22e395e",
    "metadata": {},
    "name": "ItemPickerLabelPermissionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e216265f3d36f145d200bd70529ba87d";

export default node;
